var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-checkbox",
    {
      attrs: { disabled: _vm.disabled },
      on: { change: _vm.emitChange },
      model: {
        value: _vm.checked,
        callback: function ($$v) {
          _vm.checked = $$v
        },
        expression: "checked",
      },
    },
    [_vm._v("加班申请是否遵循此规则")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }